import service from '@/services/facturacion/emisor'
import { Session } from '@/plugins/session'

const getDefaultState = () => ({
  emisor: {
    nombre: '',
    img: null,
    identificacion: { tipo: { id: '' }, numero: null },
    nombreComercial: '',
    ubicacion: {
      provincia: { id: '' },
      canton: { id: '' },
      distrito: { id: '' },
      otrasSenas: ''
    },
    telefono: { codigoPais: 506, numTelefono: null },
    correoElectronico: '',
    codigoActividad: [
      {
        documento: { id: '' },
        codigoActividad: { id: '' },
        condicionVenta: { id: '' },
        plazoCredito: 0,
        medioPago: { id: '' },
        clasificacion: 'producto',
        editarServicios: false,
        editarPrecios: false,
        modoLibre: true,
        cabys: '',
        modoivaIncluido: true,
        codigo: { id: '' },
        codigoTarifa: { id: '' },
        tarifa: 13,
        unidadMedida: { id: '' },
        codigoMoneda: { id: '' }
      }
    ],
    usernameATV: '',
    passwordATV: '',
    certificadoATV: '',
    pin: null,
    certificadoExpiracion: null
  },
  stats: {
    totales: {
      fete: [],
      mr: [],
      nc: []
    },
    estados: {}
  },
  documentosTotales: [],
  documentosRecepcionTotales: [],
  ventasMes: {},
  ventasDiarias: [],
  emisorPaymentLink: {}, // usado solo para página delink de pago
  moduloRestaurante: false, // usado solo para modulo de restaurante
  saved: 'null',
  menu: {
    show: false,
    name: 'facturar',
    url: '/facturacion/facturar'
  },
  printers: []
})

export const state = () => getDefaultState()

export const mutations = {
  SET_MENU_ACTIVE: (state, isActive) => (state.menu.show = isActive),
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_EMISOR: (state, obj) => {
    state.emisor = obj
    const { pin, certificadoExpiracion, passwordATV, usernameATV, ...rest } = obj
    console.log('[TEST] Emisor actualizado:', rest)

    state.saved = true
  },
  SET_STATS_ESTADOS: (state, obj) => {
    state.stats.estados = obj
  },
  SET_STATS_TOTALES: (state, obj) => {
    state.stats.totales.fete = obj
  },
  SET_DOCUMENTOS_TOTALES: (state, obj) => {
    state.documentosTotales = obj
  },
  SET_DOCUMENTOS_RECEPCION_TOTALES: (state, obj) => {
    state.documentosRecepcionTotales = obj
  },
  SET_VENTAS_MES: (state, obj) => {
    state.ventasMes = obj
  },
  SET_VENTAS_DIARIAS: (state, obj) => {
    state.ventasDiarias = obj
  },
  SAVE_CHANGES: (state, obj) => {
    state.emisor = obj
    state.saved = false
  },
  SET_EMISOR_NOTIFICATION: (state, obj) => {
    state.emisor = {
      ...state.emisor,
      notification: {
        orderEmail: obj?.orderEmail || '',
        orderSMS: obj?.orderSMS || false
      }
    }
  },
  SET_EMISOR_LINKS: (state, obj) => {
    state.emisorPaymentLink = {
      name: obj?.name || '',
      enablePaymentLink: obj?.enablePaymentLink || false,
      paymentUrl: obj?.paymentUrl || '',
      paymentRedirectUrl: obj?.paymentRedirectUrl || '',
      paymentType: obj?.paymentType || 'ONVO',
      onvoSecret: obj?.onvoSecret || '',

      enableNewCustomerLink: obj?.enableNewCustomerLink || false,
      newCustomerUrl: obj?.newCustomerUrl || ''
    }
  },
  SET_EMISOR_PRINTERS: (state, obj) => {
    state.printers = obj
  }
}

export const actions = {
  create: ({ commit }, { item, profile }) => {
    // elimina propiedades no utilizadas al guardar.
    const payload = JSON.parse(JSON.stringify(item))

    delete payload.codigoActividad[0].codigoMoneda.value
    delete payload.codigoActividad[0].codigoMoneda.simbolo
    delete payload.certificadoExpiracion
    delete payload.local
    delete payload.img
    delete payload.notification
    delete payload.restaurantModule
    delete payload.cashRegisterModule
    delete payload.productionModule
    delete payload.bulkBillingModule
    delete payload.billingModule
    delete payload.crmModule
    delete payload.marketingModule
    delete payload.inventoryModule
    delete payload.viajesModule
    delete payload.accountingModule
    delete payload.whatsappModule

    if (payload.certificadoATV === 'true') delete payload.certificadoATV

    return service.create(payload, profile).then(result => {
      if (result) {
        commit('SET_EMISOR', { ...item, ...result })
        // elimina los params de la factura para que sean reemplazados por los default del emisor.
        commit('facturacion/facturaStore/SET_DEFAULT_PARAMS', {}, { root: true })
        return true
      }
      return false
    })
  },

  readById: ({ commit }, id) => service.readById(id).then(result => commit('SET_EMISOR', result)),

  readByUserId: ({ commit, state }, refresh = false) => {
    if (state.emisor.id && !refresh) {
      return state.emisor
    }

    return service.readByUserId(Session.user.id).then(result => {
      if (result.emisor.length !== 0) {
        if (!result.emisor[0].codigoActividad[0].condicionVenta) result.emisor[0].codigoActividad[0].condicionVenta = { id: '' }
        if (!result.emisor[0].codigoActividad[0].medioPago) result.emisor[0].codigoActividad[0].medioPago = { id: '' }

        console.log('Params from DB 😵‍💫')
        commit('SET_EMISOR', result.emisor[0])
        return result.emisor[0]
      }

      return null
    })
  },

  saveChanges: ({ commit }, item) => commit('SAVE_CHANGES', item),

  readFacturasMesByEmisor: async ({ commit, state }, { documento, codigoMoneda }) =>
    service.readFacturasMesByEmisor(state.emisor.id, documento, codigoMoneda).then(result => commit('SET_STATS_TOTALES', result)),

  readSumaMontosFacturasMesByEmisor: async ({ commit, state }, { codigoMoneda }) =>
    service.readSumaMontosFacturasMesByEmisor(state.emisor.id, codigoMoneda).then(result => {
      commit('SET_DOCUMENTOS_TOTALES', result)
    }),

  readSumaMontosFacturasAceptadasMesByEmisor: async ({ commit, state }, { codigoMoneda }) =>
    service.readSumaMontosFacturasAceptadasMesByEmisor(state.emisor.id, codigoMoneda).then(result => {
      commit('SET_DOCUMENTOS_RECEPCION_TOTALES', result)
    }),

  readSumaMontosFacturasMesyAnteriorByEmisor: async ({ commit, state }, { codigoMoneda }) =>
    service.readSumaMontosFacturasMesyAnteriorByEmisor(state.emisor.id, codigoMoneda).then(result => {
      commit('SET_VENTAS_MES', result)
    }),

  readVentasDiarias: async ({ commit, state }, { codigoMoneda }) =>
    service.readVentasDiarias(state.emisor.id, codigoMoneda).then(result => {
      commit('SET_VENTAS_DIARIAS', result)
    }),

  readStatsByEmisor: async ({ commit, state }) => service.readStatsByEmisor(state.emisor.id).then(result => commit('SET_STATS_ESTADOS', result)),

  checkToken: async (_, { username, password }) => service.checkToken(username, password), // .then(result => {})

  readNotification: async ({ commit, state }) => service.readNotification(state.emisor.id).then(result => commit('SET_EMISOR_NOTIFICATION', result)),

  // para link de pago
  readOrderNotification: async ({ commit }, { _idEmisor }) => service.readNotification(_idEmisor).then(result => commit('SET_EMISOR_NOTIFICATION', result)),

  setNotification: async ({ commit, state }, { notification }) => service.setNotification(state.emisor.id, notification),

  setLinks: async ({ commit, state }, { links }) => service.setLinks(state.emisor.id, links),

  setModules: async (
    { state },
    {
      restaurantModule,
      cashRegisterModule,
      productionModule,
      bulkBillingModule,
      billingModule,
      crmModule,
      marketingModule,
      inventoryModule,
      viajesModule,
      accountingModule,
      whatsappModule
    }
  ) =>
    service.setModules(
      state.emisor.id,
      restaurantModule,
      cashRegisterModule,
      productionModule,
      bulkBillingModule,
      billingModule,
      crmModule,
      marketingModule,
      inventoryModule,
      viajesModule,
      accountingModule,
      whatsappModule
    ),
  readLinks: async ({ commit, state }) =>
    service.readLinks(state.emisor.id).then(result => {
      console.log('result', result)
      commit('SET_EMISOR_LINKS', result)
      return result
    }),

  readLinkByName: async ({ state }, { link }) => service.readLinkByName(link).then(result => (state.emisorPaymentLink = result || {})),

  readEmisorByDomain: async ({ commit }, domain) => service.readEmisorByDomain(domain).then(result => commit('SET_EMISOR', result)),

  // TODO: MODULO DE IMPRESORAS
  // readPrinters: async ({ commit, state }) => service.readPrinters(state.emisor.id).then(result => commit('SET_EMISOR_PRINTERS', result)),
  setPrinter: async ({ state, dispatch }, { printer }) => service.setPrinter(state.emisor.id, printer).then(() => dispatch('readPrinters'))
}

export const getters = {
  get_Id: state => state.emisor.id,
  getValues: state => state.emisor,
  getAccountingModule: state => state.emisor.accountingModule
}
